import {Component, Vue} from 'vue-facing-decorator';
import { ref } from "vue";
import Loading from 'vue-loading-overlay';
@Component({
    name: 'about-view',
    components: {       
        'loading'    : Loading,
    }
})
export default class AboutView extends Vue{
    page       = ref(null);
    loading    = false;
    message    = "";

    p = {
        "id": 26,
        "date": "2023-04-01T23:02:59",
        "date_gmt": "2023-04-01T23:02:59",
        "guid": {
            "rendered": "http://rsudgeneng.ngawikab.go.id/?page_id=26"
        },
        "modified": "2024-09-02T09:43:37",
        "modified_gmt": "2024-09-02T02:43:37",
        "slug": "sejarah",
        "status": "publish",
        "type": "page",
        "link": "https://rsudgeneng.ngawikab.go.id/sejarah/",
        "title": {
            "rendered": "Sejarah"
        },
        "content": {
            "rendered": "\n\u003Cp\u003E\u003Cstrong\u003ESejarah Pendirian Rumah Sakit Umum Daerah Geneng \u003C/strong\u003E\u003C/p\u003E\n\n\n\n\u003Cp\u003EDalam mewujudkan Visi Misi Bupati dan Wakil Bupati Kabupaten Ngawi dalam Bidang Kesehatan, maka pembangunan kesehatan di Kabupaten Ngawi dilakukan secara komprehensif, dengan tujuan untuk meningkatkan derajat kesehatan masyarakat secara nasional dan daerah (khususnya derajat kesehatan di Kabupaten Ngawi). Berbagai upaya dilakukan oleh Pemerintah Kabupaten Ngawi dalam upaya memberikan layanan kesehatan terbaik untuk masyarakat, diantaranya adalah penguatan layanan puskesmas, layanan jaminan kesehatan masyarakat Ngawi, serta pembangunan RSUD agar akses kesehatan masyarakat semakin dekat. Penguatan layanan kesehatan masyarakat diberikan dalam layanan reguler/umum, rujukan dan jaminan.\u003C/p\u003E\n\n\n\n\u003Cp\u003ERSUD Geneng diresmikan pada tanggal 7 Juli 2022 (soft launching), bertepatan dengan hari jadi Kabupaten Ngawi ke-664, oleh Bupati Ngawi Bpk. Ony Anwar Harsono, ST, MH. Untuk yang pertama kali, Direktur RSUD Geneng dijabat oleh Ibu dr. Endri Agustin M.Kes\u003C/p\u003E\n\n\n\n\u003Cp\u003EPembangunan RSUD Geneng Kabupaten Ngawi dimulai sejak tahun 2020, bertempat kedudukan di Jl. Raya Ngawi &#8211; Madiun KM 09, Desa Tambakromo, Kecamatan Geneng, Kabupaten Ngawi. RSUD Geneng merupakan rumah sakit milik Pemerintah Kabupaten Ngawi, yang bertugas menyelenggarakan pelayanan kesehatan kepada masyarakat dengan upaya pencegahan, penyembuhan, pemulihan, peningkatan, pelayanan rujukan, serta pengabdian masyarakat.\u003C/p\u003E\n\n\n\n\u003Cp\u003ERSUD Geneng berdiri di lokasi strategis, yaitu di bekas kantor UPTD Pertanian dan Puskesmas Geneng dengan batas sebelah utara Kantor Kecamatan Geneng, dan di sebelah selatan SD Negeri I Tambakromo. Saat ini, bangunan RSUD Geneng terdiri atas 2 (dua) area, yaitu gedung existing Puskesmas Geneng (lama) dengan luas lahan 1.335 m2 dan luas bangunan 1335 m2 serta bangunan gedung baru seluas 9.985 m2 , lahan parkir 1.225 m2 dan ruang terbuka (taman, sirkulasi, jalan) seluas 4.590 m2. Luas lahan keseluruhan gedung baru RSUD Geneng Kabupaten Ngawi (termasuk lahan pengembangan) adalah 15.800 m2. Sesuai&nbsp; Peraturan Menteri Kesehatan Republik Indonesia No 24 tahun 2014 tentang Rumah Sakit, Rumah Sakit Umum Daerah Geneng Kabupaten Ngawi Provinsi Jawa Timur di termasuk rumah sakit Kelas D.\u003C/p\u003E\n",
            "protected": false
        },
        "excerpt": {
            "rendered": "\u003Cp\u003ESejarah Pendirian Rumah Sakit Umum Daerah Geneng Dalam mewujudkan Visi Misi Bupati dan Wakil Bupati Kabupaten Ngawi dalam Bidang Kesehatan, maka pembangunan kesehatan di Kabupaten Ngawi dilakukan secara komprehensif, dengan tujuan untuk meningkatkan derajat kesehatan masyarakat secara nasional dan daerah (khususnya derajat kesehatan di Kabupaten Ngawi). Berbagai upaya dilakukan oleh [&hellip;]\u003C/p\u003E\n",
            "protected": false
        },
        "author": 1,
        "featured_media": 0,
        "parent": 0,
        "menu_order": 0,
        "comment_status": "closed",
        "ping_status": "closed",
        "template": "",
        "meta": {
            "_joinchat": [],
            "footnotes": ""
        },
        "class_list": [
            "post-26",
            "page",
            "type-page",
            "status-publish",
            "hentry"
        ],
        "jetpack_sharing_enabled": true,
        "_links": {
            "self": [
            {
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/26",
                "targetHints": {
                "allow": [
                    "GET"
                ]
                }
            }
            ],
            "collection": [
            {
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages"
            }
            ],
            "about": [
            {
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/types/page"
            }
            ],
            "author": [
            {
                "embeddable": true,
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/users/1"
            }
            ],
            "replies": [
            {
                "embeddable": true,
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/comments?post=26"
            }
            ],
            "version-history": [
            {
                "count": 3,
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/26/revisions"
            }
            ],
            "predecessor-version": [
            {
                "id": 800,
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/26/revisions/800"
            }
            ],
            "wp:attachment": [
            {
                "href": "https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/media?parent=26"
            }
            ],
            "curies": [
            {
                "name": "wp",
                "href": "https://api.w.org/{rel}",
                "templated": true
            }
            ]
        }
        };
    async mounted () {
        this.message = ""
        this.loading = true;
        try {
            const response = await fetch('https://rsudgeneng.ngawikab.go.id/wp-json/wp/v2/pages/26');
            this.page = await response.json();
        }catch (error) { 
            console.log(error)
            this.message = "Maaf, Terjadi Kendala!!"
        }
        this.loading = false;

        this.$nextTick(() => {
            const iframes = document.querySelectorAll('#my-konten iframe');
            iframes.forEach((iframe :any) => {
              iframe.style.width = '100%';
              iframe.style.height = 'auto';
            });

            const img = document.querySelectorAll('#my-konten img');
            img.forEach((img :any) => {
                img.style.width = '100%';
                img.style.height = 'auto';
              });
        });
    }


}